import { render, staticRenderFns } from "./CrmTrigger.vue?vue&type=template&id=352f44e2"
import script from "./CrmTrigger.vue?vue&type=script&lang=js"
export * from "./CrmTrigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports